import { defineComponent as _defineComponent } from 'vue'
import PlanBenefits from '@/components/billing/PlanBenefits.vue';
import { CurrencyCode, UnitPrice } from '@paddle/paddle-js';
import { TimePeriod } from '@paddle/paddle-js/types/shared/shared';
import { computed, toRefs } from 'vue';

type CurrencyCodeLocal = 'USD' | 'EUR' | 'UAH';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanTab',
  props: {
    price: null,
    period: null,
    trialPeriod: null,
    description: null,
    productName: null,
    isUpdatePlan: { type: Boolean }
  },
  emits: ['subscribe', 'update'],
  setup(__props: any, { emit }) {

const props = __props as {
  price: UnitPrice;
  period: string;
  trialPeriod: TimePeriod;
  description: string;
  productName: string;
  isUpdatePlan: boolean;
}


const { price, period, trialPeriod, description, productName } = toRefs(props);


/**
 * "14-day free trial", not "14-days free trial" — the interval is a hyphenated
 * compound modifier, so it stays singular however long the trial is (SNAP-2231
 * QA flagged the trial wording). Paddle sends `interval` already singular
 * ('day' | 'week' | 'month' | 'year').
 */
const trialLabel = computed(() =>
  trialPeriod.value ? `${trialPeriod.value.frequency}-${trialPeriod.value.interval} free trial` : ''
);

// H6: `+price.amount / 100` already renders the decimal part (e.g. 9.99) —
// appending a literal ".00" produced "$ 9.99.00" for any non-round-dollar
// price, masked before only because the sole live price was the $0 trial.
const formattedAmount = computed(() => (+price.value.amount / 100).toFixed(2));

const currencySymbol = (code: CurrencyCode | CurrencyCodeLocal): string => {
  const symbols: Record<CurrencyCodeLocal, string> = {
    USD: '$',
    EUR: '€',
    UAH: '₴',
  };

  return symbols[code as CurrencyCodeLocal] || '';
};

return { __sfc: true,props, price, period, trialPeriod, description, productName, emit, trialLabel, formattedAmount, currencySymbol, PlanBenefits }
}

})